export default __webpack_public_path__ + "static/iam-8572b9b65a8657e9f76ca68a8318fc20.png";